import {
	TFileId,
	IMenuTranslation,
	IItemForGetShortInfo,
	IItemForGetShortInfoWithStatus,
	ICustomerLanguageInfo,
	IDishSubCategoryForPagination,
	DirectionForPaginated,
	ITranslationInfo,
	EntityStatus,
} from 'types';

export interface IRestaurantsSubCategories {
	id: string;
	restaurantName: Nullable<string>;
	restaurantStatus: EntityStatus;
	categoryId: string;
	subCategoryId: string;
	positionNumber: number;
	categoryName: Nullable<string>;
	subCategoryName: Nullable<string>;
	isHidden: boolean;
	isAvailableForRepetition: boolean;
}

export interface IDishesForSubCategory {
	id: string;
	dishId: string;
	dishName: Nullable<string>;
	positionNumber: number;
	subCategoryName: Nullable<string>;
}

export interface ISubCategoryAllDishes {
	id: string;
	dishName: Nullable<string>;
}

export interface IItemSubCategory {
	id: string;
	name: Nullable<string>;
	filePath: Nullable<string>;
	customerId: string;
	customerName: Nullable<string>;
	categoryId: string;
	categoryName: Nullable<string>;
	withAssignedDishes: boolean;
	restaurantsSubCategories: IRestaurantsSubCategories[];
	dishes: IDishesForSubCategory[];
	allDishes: ISubCategoryAllDishes[];
	activationCron: string | null;
	deactivationCron: string | null;
}

// Menu v1
export interface ISubCategory {
	subCategoriesCount: number;
	subCategories: IItemSubCategory[];
}
// Menu v1
// Menu v2
export interface ISubcategoryByCustomerV2 {
	totalCount: number;
	items: {
		id: string;
		name: Nullable<string>;
		restaurants: IItemForGetShortInfo[];
		category: IItemForGetShortInfo;
		preSignedUrl?: Nullable<string>;
	}[];
}

export interface ISubcategoryByRestaurantV2 {
	totalCount: number;
	items: {
		id: string;
		name: Nullable<string>;
		isHidden: boolean;
		availableForRepetition: boolean;
		category: IItemForGetShortInfo;
		preSignedUrl?: Nullable<string>;
	}[];
}
// Menu v2

// Menu v1
interface IDataGetSubCategoryInfo extends IItemSubCategory {
	preSignedUrl: Nullable<string>;
	// dishes: ISubCategoryDishes[];
	customer: ICustomerLanguageInfo | null;
	translations: IMenuTranslation[];
}

export interface IGetSubCategoryInfo {
	data: {
		subCategory: IDataGetSubCategoryInfo;
	};
}
// Menu v1
// Menu v2
export interface IDataGetSubcategoryInfoV2 {
	id: string;
	name: Nullable<string>;
	customer: IItemForGetShortInfo;
	category: IItemForGetShortInfo;
	restaurants: IItemForGetShortInfoWithStatus[];
	photoPath: Nullable<string>;
	activationCron: Nullable<string>;
	deactivationCron: Nullable<string>;
	overrideScheduleAvailability: boolean;
	translations: ITranslationInfo[];
}

export interface IGetSubcategoryInfoV2 {
	data: IDataGetSubcategoryInfoV2;
}
// Menu v2

export interface ISubCategoryDishes extends IDishSubCategoryForPagination {
	subCategoryName: string;
	dishName: string;
}

export type TQueryForGetSubCategoriesShort = 'categoryId' | 'customerId';

export interface IGetSubCategoriesShort {
	data: {
		subCategories: IItemForGetShortInfo[];
	};
}

export interface IGetSubCategoriesArguments {
	categoryId: string;
	restaurantId?: string;
}

// Menu v1
export interface IGetPaginatedSubCategories {
	pageNumber: number;
	pageSize: number;
	searchByName: Nullable<string>;
	customerId: Nullable<string>;
	restaurantId: Nullable<string>;
	categoryId: Nullable<string>;
	isHidden: boolean;
	sortByCustomer: Nullable<string>;
	sortByCategories: Nullable<string>;
	sortBySubCategories: Nullable<string>;
}
// Menu v1
// Menu v2
export enum SortByForPaginatedSubcategories {
	Name = 'Name',
}

export interface IGetPaginatedSubcategoriesByCustomerV2 {
	customerId: string;
	pageNumber: number;
	pageSize: number;
	searchInput: Nullable<string>;
	sorting: Nullable<{
		sortBy: SortByForPaginatedSubcategories;
		direction: DirectionForPaginated;
	}>;
}

export interface IGetPaginatedSubcategoriesByRestaurantV2 {
	restaurantId: string;
	categoryId: Nullable<string>;
	pageNumber: number;
	pageSize: number;
	searchInput: Nullable<string>;
	isHidden: boolean;
	sorting: Nullable<{
		sortBy: SortByForPaginatedSubcategories;
		direction: DirectionForPaginated;
	}>;
}
// Menu v2

export interface ISubCategoryRestaurants {
	restaurantId: string;
	isHidden: boolean;
	isAvailableForRepetition: boolean;
}

// Menu v1
export interface ICreateSubCategory {
	name: string;
	customerId: string;
	categoryId: Nullable<string>;
	fileId: TFileId;
	subCategoryRestaurants: ISubCategoryRestaurants[];
	activationCron: string | null;
	deactivationCron: string | null;
	translations: IMenuTranslation[];
}
// Menu v1
// Menu v2
export interface ICreateSubcategoryV2 {
	name: string;
	customerId: string;
	categoryId: string;
	fileId: TFileId;
	translations: IMenuTranslation[];
	overrideScheduleAvailability: boolean;
	activationCron: Nullable<string>;
	deactivationCron: Nullable<string>;
	restaurantIds: string[];
}
// Menu v2

// Menu v1
export interface IUpdateSubCategory {
	id: string;
	name: string;
	customerId: string;
	categoryId: Nullable<string>;
	fileId: TFileId;
	subCategoryRestaurants: ISubCategoryRestaurants[];
	activationCron: string | null;
	deactivationCron: string | null;
	translations: IMenuTranslation[];
}
// Menu v1
// Menu v2
export interface IUpdateSubcategoryV2 {
	id: string;
	name: Nullable<string>;
	fileId: TFileId;
	activationCron: Nullable<string>;
	deactivationCron: Nullable<string>;
	overrideScheduleAvailability: boolean;
	restaurantIds: string[];
	translations: IMenuTranslation[];
}
// Menu v2

// Menu v1
export interface ISubCategoryPositionItem {
	id: string;
	name: string | null;
	positionNumber: number;
	filePath: string | null;
	customer: { id: string; name: string };
	category: { id: string; name: string };
	restaurants: { id: string; name: string; isHidden: boolean }[];
}

export interface IGetSubCategoryPositionListArguments {
	restaurantId: string;
	categoryId: string;
}

export interface IGetSubCategoryPositionList {
	data: {
		subCategoryPositions: ISubCategoryPositionItem[];
	};
}
// Menu v1
// Menu v2
export interface ISubCategoryPositionItemV2 {
	id: string;
	name: Nullable<string>;
	positionNumber: number;
	isHidden: boolean;
	availableForRepetition: boolean;
	preSignedUrl?: Nullable<string>;
}

export interface IGetSubCategoryPositionListV2 {
	data: {
		subCategories: ISubCategoryPositionItemV2[];
	};
}
// Menu v2

export interface ISubCategoryPositionChain {
	id: string;
	name: string;
	address: string;
	status: EntityStatus;
}

export interface IGetSubCategoryPositionChainsArguments {
	restaurantId: string;
	categoryId: string;
}

export interface IGetSubCategoryPositionChains {
	data: {
		restaurants: ISubCategoryPositionChain[];
	};
}

export interface IUpdateSubCategoryPositions {
	restaurantIds: string[];
	categoryId: string;
	subCategoryIds: string[];
}

export interface IGetSubcategoryRestaurantPropertiesArguments {
	restaurantId: string;
	subcategoryId: string;
}

export interface IGetSubcategoryRestaurantProperties {
	data: {
		id: string;
		name: Nullable<string>;
		category: IItemForGetShortInfo;
		customer: IItemForGetShortInfo;
		restaurantId: Nullable<string>;
		dishes: IItemForGetShortInfo[];
		activationCron: Nullable<string>;
		deactivationCron: Nullable<string>;
		availableForRepetition: boolean;
		isHidden: boolean;
	};
}

export interface IUpdateSubcategoryRestaurantProperties {
	subcategoryId: string;
	restaurantId: string;
	activationCron: Nullable<string>;
	deactivationCron: Nullable<string>;
	availableForRepetition: boolean;
	isHidden: boolean;
}

export type TPropertiesOfPatchChangesForSubcategory =
	| 'activation'
	| 'deactivation'
	| 'availableForRepetition'
	| 'hideSubcategory';

export interface IPropertiesOfPatchChangesForSubcategory {
	id: TPropertiesOfPatchChangesForSubcategory;
	name: TPropertiesOfPatchChangesForSubcategory;
}

export interface IUpdateRestaurantPropertiesAsPatchForSubcategory {
	subCategoryId: string;
	restaurantIds: string[];
	update: {
		activationCron: {
			shouldUpdate: boolean;
			value: string;
		};
		deactivationCron: {
			shouldUpdate: boolean;
			value: string;
		};
		availableForRepetition: {
			shouldUpdate: boolean;
			value: boolean;
		};
		isHidden: {
			shouldUpdate: boolean;
			value: boolean;
		};
	};
}
